import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../shared/shared.module';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { DonationComponent } from './donation.component';
import { DonationsListModule } from './donations-list/donations-list.module';

@NgModule({
    imports: [
      CommonModule,
      BrowserModule,
      NgbModule,
      SharedModule,
      BsDatepickerModule,
      DonationsListModule
    ],
    declarations: [DonationComponent],
    exports: [DonationComponent],
    entryComponents: []
  })
  export class DonationModule {}
